import Highcharts from 'highcharts';
import { formatNumberToString } from '../../../utils/numberFormat';

export const formatYAxisLabel = (
  value: number,
  isPercentage: boolean,
): string => formatNumberToString(value, isPercentage);

export const createDefaultYAxisOptions = (
  presentationFont: boolean,
  isPercentage: boolean,
): Highcharts.YAxisOptions => ({
  max: null,
  title: null,
  tickWidth: 0,
  tickLength: 5,
  tickColor: '#eceff2',
  lineColor: '#eceff2',
  gridLineColor: '#eceff2',
  labels: {
    style: {
      fontSize: presentationFont ? '14px' : '10px',
      color: '#666',
    },
    formatter () {
      const value =
        typeof this.value === 'number' ? this.value : parseInt(this.value, 10);
      return formatYAxisLabel(value, isPercentage);    },
  },
});
